export default "__VITE_ASSET__BSXzbPFG__"